module.exports = __webpack_public_path__ + "media/images/warnings/warning_1-4ee9bc230c990081e77df2c79d9999e9.svg";